// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
export const isMobileOrTablet = () => {
  const isMobile =
    /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(
      navigator.userAgent
    );
  return isMobile;
};

export const isOnlyMoblie = () => {
  const isMobile = /iPhone|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(
    navigator.userAgent
  );
  return isMobile;
};
